import React from 'react'
import { getHexColor, TwoColorIconProps } from '../utils'

export const ParentalControlsIcon: React.FC<TwoColorIconProps> = ({
  size = 24,
  color1 = 'white',
  color2 = '#21CEA0',
  className,
}) => {
  const hex = getHexColor(color1)
  const checkedHex = getHexColor(color2)

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8458 5.70024L11.4 1.97869L1.95429 5.70024V7.95862C1.9544 13.9539 5.6216 19.4311 11.4 22.0102C17.1785 19.4311 20.8457 13.9539 20.8458 7.95862V5.70024ZM22.8001 7.95862C22.8 14.8287 18.5677 21.0235 12.0413 23.8665C11.6328 24.0445 11.1673 24.0445 10.7588 23.8665C4.23237 21.0235 0.000109748 14.8287 0 7.95862V5.47886C0 4.80982 0.409383 4.20874 1.03186 3.96352L10.8033 0.113455L10.9484 0.0638342C11.2433 -0.0212783 11.5568 -0.0212778 11.8517 0.0638342L11.9968 0.113455L21.7682 3.96352C22.3907 4.20874 22.8001 4.80982 22.8001 5.47886V7.95862Z"
        fill={hex}
      />
      <path
        d="M16.9381 8.10997C16.938 8.3817 16.8494 8.62864 16.6569 8.8212L10.4454 15.0327C10.3506 15.1273 10.2378 15.2046 10.1057 15.2515C10.0471 15.2725 9.98789 15.2886 9.92754 15.2986L9.74305 15.3139C9.62009 15.3138 9.49802 15.295 9.38044 15.2528C9.24862 15.2058 9.13541 15.1273 9.04073 15.0327L6.13728 12.1292C5.9428 11.9346 5.85624 11.684 5.86373 11.4091C5.87181 11.1407 5.96429 10.8964 6.15382 10.7068L6.22761 10.6394C6.40588 10.4942 6.62251 10.4257 6.85742 10.4256C7.12609 10.4258 7.36929 10.5165 7.55974 10.7068L9.74305 12.8901L15.2344 7.39874C15.4269 7.20621 15.6744 7.11777 15.9456 7.11755L16.1441 7.13409C16.3373 7.16801 16.5124 7.25443 16.6569 7.39874C16.8495 7.59138 16.9381 7.83855 16.9381 8.10997Z"
        fill={checkedHex}
      />
    </svg>
  )
}
